import {
    Grid,
    Box,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio,
    OutlinedInput,
    InputAdornment,
    Button,
    FormControl
} from "@mui/material";
import pr from "../lib/pr";
import get_token from "../lib/get_token";
import { loginState, configState } from "../lib/State"; // 로그인 (1)
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import get_cid from '../lib/get_cid';

function MypageEdit(props) {
    const { login, onClose } = props;
    const token = get_token();
    const { mcd, level } = login;
    const cid = get_cid();
    const [birth, setBirth] = useState('');
    const [sex, setSex] = useState('');
    const [weight, setWeight] = useState('');
    const [height, setHeight] = useState('');

    const load_data = async () => {
        let result = await axios.post(configState.api + "/gympass/my_info", {
            token: token,
            level: level,
            mcd: mcd,
            cid: cid,
        });
        pr(result.data.row);
        setBirth(result.data.row.birth);
        setSex(result.data.row.sex);
        setWeight(result.data.row.weight);
        setHeight(result.data.row.height);
    }
    useEffect(() => {
        load_data();
    }, []);

    const onEditClick = async () => {
        let result = await axios.post(configState.api + "/gympass/my_info_edit", {
            token: token,
            level: level,
            mcd: mcd,
            cid: cid,
            birth: birth,
            sex: sex,
            weight: weight,
            height: height,
        });
        if (result.data.success === 1) {
            Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
                (result) => {
                    onClose();
                });
        }
        else {
            Swal.fire(result.data.msg);
        }
    }

    return (
        <Grid
            container
            height="100vh"
            direction="column"
            marginTop='20px'
            alignItems='center'
        // justifyContent="center"
        >
            <Grid
                container
                width="85%"
                padding="5px"
                flexDirection='column'>
                {/* <Box sx={{
                        marginBottom: "5px",
                    }}>
                        생년월일
                    </Box> */}
                <Box sx={{ width: "60%" }}>
                    <TextField
                        fullWidth
                        autoComplete="off"
                        name="birth"
                        value={birth}
                        label="생년월일 (예:20210101)" size="small"
                        onChange={(e) => { setBirth(e.target.value) }
                        }
                    ></TextField>
                </Box>

                <Box sx={{ width: '60%' }}>
                    <FormControl sx={{ mt: 2 }} fullWidth>
                        <TextField
                            size="small"
                            label="키"
                            type="number"
                            value={height}
                            onChange={(e) => { setHeight(e.target.value) }}
                            InputProps={{ endAdornment: <InputAdornment position="end">cm</InputAdornment> }}
                        ></TextField>
                    </FormControl>
                </Box>

                <Box sx={{ width: '60%' }}>
                    <FormControl sx={{ mt: 2 }} fullWidth>
                        <TextField
                            size="small"
                            label="체중"
                            type="number"
                            value={weight}
                            onChange={(e) => { setWeight(e.target.value) }}
                            InputProps={{ endAdornment: <InputAdornment position="end">kg</InputAdornment> }}
                        ></TextField>
                    </FormControl>
                </Box>
                <Box sx={{ mt: 2, pl: 1 }}>
                    키와 체중은 심박계 이용 시 칼로리 계산을 위해 사용됩니다.
                </Box>
            </Grid>
            

            <Grid
                container
                display="flex"
                justifyContent="center"
                paddingTop="20%">
                <Button variant="contained" sx={{ width: "40%", margin: "5px", background: "#0092a2" }} onClick={onEditClick}>수정</Button>
                <Button variant="outlined" sx={{ width: "40%", margin: "5px", border: "1px solid gray", color: "gray" }} onClick={onClose}>취소</Button>


            </Grid>

        </Grid>
    )
}

export default MypageEdit;